var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import axios from "axios";
import { generateUUID } from "./index";
import { SentryUtils } from "./SentryUtils";
import { Logger } from "./Logger";
export class Sentry extends SentryUtils {
    static init(options) {
        const { baseApiUrl, publicKey } = this.parseDSN(options.sentryDSN);
        this.options = options;
        this.BASE_API_URL = baseApiUrl;
        this.PUBLIC_KEY = publicKey;
        this.isInitialized = true;
    }
    static captureError(error, extraData) {
        if (!this.isInitialized) {
            return;
        }
        try {
            const exception = this.buildSentryExceptionFromAppError(error, { isHandled: true });
            this.processException(exception, extraData);
        }
        catch (err) {
            this.logger.error('"captureError" failed', err);
        }
    }
    static processException(exception, extraData) {
        const eventId = generateUUID();
        const timestamp = new Date().toISOString();
        const envelopeHeaders = JSON.stringify({
            sent_at: timestamp,
            event_id: eventId,
        });
        const itemPayload = JSON.stringify({
            timestamp,
            platform: "javascript",
            level: "error",
            release: this.options.buildVersion,
            environment: this.options.env,
            exception: [exception],
            extra: extraData,
            contexts: this.buildExceptionContexts(),
            tags: {
                domain: window.location.origin,
                integration_app: this.options.integrationApp,
            },
        });
        const itemHeaders = JSON.stringify({
            type: "event",
            length: new Blob([itemPayload]).size,
        });
        const requestPayload = `${envelopeHeaders}\n${itemHeaders}\n${itemPayload}\n`;
        this.sendEventToSentry(requestPayload).catch(this.handleRequestError);
    }
    static sendEventToSentry(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isApiRequestsSuppressed) {
                return;
            }
            const url = `${this.BASE_API_URL}/envelope/`;
            const headers = {
                "Content-Type": "text/plain",
                "X-Sentry-Auth": `Sentry sentry_version=7, sentry_key=${this.PUBLIC_KEY}`,
            };
            yield axios.post(url, payload, { headers });
        });
    }
    static handleRateLimitExceededError(error) {
        var _b;
        this.isApiRequestsSuppressed = true;
        const sentryDefaultRateLimitSec = 60;
        const retryAfterSec = ((_b = error.response) === null || _b === void 0 ? void 0 : _b.headers["Retry-After"]) || sentryDefaultRateLimitSec;
        setTimeout(() => {
            this.isApiRequestsSuppressed = false;
        }, retryAfterSec * 1000);
    }
}
_a = Sentry;
Sentry.logger = new Logger("Sentry");
Sentry.isInitialized = false;
Sentry.isApiRequestsSuppressed = false;
Sentry.handleRequestError = (error) => {
    switch (error.status) {
        case 429:
            _a.handleRateLimitExceededError(error);
            break;
        default:
            _a.logger.error(error);
    }
};
